module.exports = __webpack_public_path__ + "img/LV40103303559.f600d6f2.png";